export function clearUser(navigate) {
  localStorage.clear();
  navigate("/", { replace: true });
}
